<template>
  <v-app id="app">
    <navbar v-if="statusLogin"></navbar>
    <Notifications></Notifications>
    <v-content>
      <router-view :key="$route.fullPath"></router-view>
    </v-content>
    <!-- <v-footer  v-if="statusLogin" app dark fixed>
      <span class="white--text">{{ title }} &copy; 2017</span>
    </v-footer>-->
  </v-app>
</template>

<script>
/** TODO:
 * - Added base autocomplete place components
 * - Change add favorite menu into navbar by right click
 * - Added New UI Navbar (show user info)
 *
 * - Added global submit buttom components and first using on (GI) components
 * - Added condition to clear data of place selection such as region, province, district, sub dis.. into Dialog Festival Place
 * - Added global product search components and first using on raw data
 * - Added notification module for handle all response status from api
 * - Added NProgress plugin for watch all call from api axios
 * - Added notification module into vehicle type vuex module
 * - Change vehicle type components to use map helpers from vuex
 * - Added Not Found components and route for handle error for unknown URL
 * - Added Network Issue components and route for handle error for api timeout
 * FIXME:
 *
 *
 */
import Notifications from './components/Notifications.vue'
import navbar from './components/TheNavbar'
export default {
  name: 'app',
  data() {
    return {
      title: this.$appName,
      statusLogin: true
    }
  },
  props: {
    source: String
  },
  components: {
    Notifications,
    navbar
  },
  created() {
    this.checkSession()
  },
  updated() {
    this.checkSession()
  },
  methods: {
    checkSession: function() {
      // has login
      if (this.$session.has('userid')) {
        this.statusLogin = true
      } else {
        this.statusLogin = false
      }
    }
  }
}
</script>

<style lang="scss">
//9e9e9e
$menuColor: #c8cfd3;
/* Css framework */
@import url('https://cdn.materialdesignicons.com/2.1.99/css/materialdesignicons.min.css');
@import url('https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css');

/* Css Pulgin */
@import '../node_modules/iziToast/dist/css/iziToast.min.css';

/* Media query */
@import 'mq';

/* Google font */
@import url('https://fonts.googleapis.com/css?family=Secular+One:300,400');
@import url('https://fonts.googleapis.com/css?family=Quicksand:300,400');
@import url('https://fonts.googleapis.com/css?family=Prompt:300,400,600');
@import url('https://fonts.googleapis.com/icon?family=Material+Icons');
@import url('https://fonts.googleapis.com/css?family=Kanit:300,400,500,700');

html {
  font-size: 100%;
  // // overflow:hidden!important;
  /* เพื่อให้ 1rem มีค่าประมาณ 16px */
}
body,
.v-input__control,
.v-label {
  font-size: 12px !important;
  /* มีค่าประมาณ 16px */
  // font-family: Quicksand;
  // font-family: Prompt;
  // font-family: 'Roboto';
  font-weight: 300;
}
td {
  height: 24px !important;
  font-size: 1em !important;
  font-weight: 300 !important;
  cursor: pointer;
}
.bg-main {
  background-color: #303030 !important;
}

#app {
  font-family: 'Kanit' !important;
  // font-family: 'Secular One' !important;
  // font-family: 'Quicksand' !important;
  & .head-page {
    // font-family: 'Quicksand' !important;
  }
}

.v-content {
  background-color: #fff;
}
.v-tabs__wrapper {
  overflow-x: hidden !important;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.v-list--group .v-list__tile {
  padding-left: 36px !important;
}
#menu-list {
  padding-top: 24px;
  & .v-list__tile {
    color: $menuColor;
    font-weight: 300;
    height: 28px;
    padding-right: 0px;
    & .icon {
      color: $menuColor;
    }
  }
  & .v-list__group__header__prepend-icon {
    padding-left: 28px;
    min-width: 30px;
  }
  // & .v-list__tile--active {
  // color: #169be7 !important;
  // background-image: linear-gradient(to right, #4481eb 0%, #04befe 100%);
  // &:hover {
  //   background-image: linear-gradient(
  //     to right,
  //     #4481eb 0%,
  //     #04befe 100%
  //   ) !important;
  // }
  // }
}
.search-box {
  & .v-input__control {
    min-height: 30px !important;
  }
  & .v-input__slot {
    padding: 0 24px !important;
    border-radius: 24px !important;
    box-shadow: none !important;
    min-height: 30px !important;
    background: #eef1f2 !important;
  }
  &.v-text-field input {
    font-size: 14px;
  }
  & .input-group__input {
    padding: 0 16px !important;
  }
  & label {
    font-size: 12px;
  }
}
.menu__content--dropdown {
  margin-top: 10px;
}
.input-group--text-field input,
.input-group--text-field textarea,
.input-group label,
.v-list__tile,
.input-group--select .input-group__selections__comma {
  font-size: 1em !important;
}
.input-group--select.input-group--focused .input-group--select__autocomplete {
  padding-bottom: 0px !important;
}
#role {
  & table.table thead th:not(:first-child) {
    padding: 0 12px !important;
  }
}
#navbar {
  & .autocomplete__box {
    padding: 6px 16px !important;
    color: #303030;
    & .autocomplete__icon {
      margin-left: 10px !important;
    }
  }
}
#count-cropperz-othername {
  & .v-badge__badge {
    font-size: 10px;
    width: 18px;
    height: 18px;
    left: -20px;
    top: -9px;
  }
}
#product,
#parts,
#product-variety,
#product-parts,
#farmerspace-content,
#product-content,
#seasonality,
#seasonality-product,
#farmerspace-choice,
#product-view,
#workflow,
#parameters,
#vehicle,
#place,
#app {
  table.v-table tbody td:first-child,
  table.v-table tbody td:not(:first-child),
  table.v-table tbody th:first-child,
  table.v-table tbody th:not(:first-child),
  table.v-table thead td:first-child,
  table.v-table thead td:not(:first-child),
  table.v-table thead th:first-child,
  table.v-table thead th:not(:first-child) {
    padding: 0 12px;
  }
}
// #navbar {
//   &.theme--dark.v-list .v-list__group--active:after,
//   .theme--dark.v-list .v-list__group--active:before {
//     background: transparent !important;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/App.vue